import React from 'react';
import { Flexbox } from '@hiiretail/synergy-ui';
import styled from 'styled-components';

const headerHeight = '56px';
const breadcrumbsHeight = '36px';

const StyledFlexbox = styled(Flexbox)`
  width: 100%;
  height: calc(100% - (${headerHeight} + ${breadcrumbsHeight}));
  padding: ${({ theme }) => theme.spacing(4)}px ${({ theme }) => theme.spacing(8)}px;
  overflow: hidden;
`;

export const PageWrapper: React.FC<React.PropsWithChildren> = ({ children }) => (
  //@ts-ignore
  <StyledFlexbox container item direction="column">
    {children}
  </StyledFlexbox>
);
